// extracted by mini-css-extract-plugin
export default {"card":"uY-z","carouselContainer":"vY-z","carouselContent":"wY-z"};